import { em, math } from 'polished'
import styled, { css } from 'styled-components'

import DynamicImage from 'components/DynamicImage'
import { Text } from 'styles/components/typography'

import CartItemLayout from '../CartItemLayout'

export const CartProductBlock = styled(CartItemLayout)`
  border-top: 1px solid ${p => p.theme.colors.blackOp15};
  background: ${({ isEmpty, theme }) =>
    isEmpty ? theme.colors.catskillWhite : theme.colors.white};

  &:last-child {
    border-bottom: 1px solid ${p => p.theme.colors.blackOp15};
  }

  ${p => p.theme.mq.upMd} {
    border-top: 1px solid ${p => p.theme.colors.blackOp07};

    &:last-child {
      border-bottom: 1px solid ${p => p.theme.colors.blackOp07};
    }
  }

  ${p => p.theme.mq.upLg} {
    margin-bottom: ${({ isEmpty }) => (isEmpty ? em(20) : 0)};
    margin-top: ${({ isEmpty }) => (isEmpty ? em(20) : 0)};
    min-height: ${em(180)};
  }

  ${({ isSpecial }) =>
    isSpecial &&
    css`
      color: ${p => p.theme.colors.white};
      background: ${p => p.theme.colors.seaBlue};
    `}

  ${({ isEmpty }) =>
    isEmpty &&
    css`
      ${p => p.theme.mq.upLg} {
        border-radius: ${p => p.theme.blocks.blockBorderRadiusMedium};

        padding-top: ${em(25)};
        padding-bottom: ${em(27)};

        &,
        &:last-child {
          border: none;
        }


        // Second '&' include isEmpty condition and select next block with the same className
        // & + && {
        //   margin-top: ${em(20)};
        // }

        & + & {
          border-top: 0;
        }
      }
    `}
`

export const ButtonBlockMobile = styled.div`
  min-width: ${p => p.theme.buttons.hActionBtnSlim};
  text-align: right;

  ${p => p.theme.mq.upMd} {
    display: none;
  }
`

export const ButtonBlockDesktop = styled.div`
  display: none;

  ${p => p.theme.mq.upMd} {
    display: block;
  }
`

export const DynamicImageStyled = styled(DynamicImage)`
  display: none;
  height: auto;
  position: absolute;

  ${({ isSpecial }) =>
    isSpecial &&
    css`
      display: block;
      position: relative;
      width: ${em(104)};
      margin-bottom: ${em(10)};
    `}

  ${p => p.theme.mq.upMd} {
    display: inline-block;
    width: ${em(104)};
    top: ${em(6)};
    right: ${em(5)};

    ${({ isSpecial }) =>
      isSpecial &&
      css`
        position: absolute;
        margin-bottom: 0;
      `}
  }

  ${p => p.theme.mq.upLg} {
    width: ${em(150)};
    top: 50%;
    right: 50%;
    transform: translate(50%, -50%);
    padding-right: ${em(7)};
    margin-top: ${em(2)};
  }
`

export const CostBlock = styled.div`
  ${p => p.theme.mq.upLg} {
    position: absolute;
    left: ${p => math(`${p.theme.indents.baseIndentMd} / 2`)};
    top: 50%;
    transform: translateY(-50%);
  }
`

export const TextCartEmpty = styled(Text)`
  color: ${p => p.theme.colors.blackOp7};
  line-height: ${p => p.theme.typography.textSmallDescrLh};

  ${p => p.theme.mq.upMd} {
    line-height: ${p => p.theme.typography.textSmallDescrLh};
  }
`
